import { Typography } from "@mui/material";
import ClientFormsStepper from "../components/ClientFormsStepper";
import { useState, useRef, useEffect, useContext } from "react";
import ClientUserForm from "../components/ClientUserForm";
import { ClientFormFooter } from "../components/ClientFormFooter";
import ClientCollaboratorsForm from "../components/ClientCollaboratorsForm";
import ClientDetailsForm from "../components/ClientDetailsForm";
import ClientLayoutForm from "../components/ClientLayoutForm";
import ClientPlanForm from "../components/ClientPlanForm";
import { ClientsContext } from "../context/ClientsContextProvider";
import { clientsApi } from "../../../services/api";

export default function NewClient() {
  const [selectedStep, setSelectedStep] = useState(0);
  const clientDetailsFormRef = useRef<HTMLFormElement | null>(null);
  const planFormRef = useRef<HTMLFormElement | null>(null);
  const clientUserFormRef = useRef<HTMLFormElement | null>(null);
  const collaboratorsFormRef = useRef<HTMLFormElement | null>(null);
  const layoutFormRef = useRef<HTMLFormElement | null>(null);
  const handleClientDetailsFormSubmit = async () => {
    if (clientDetailsFormRef.current) clientDetailsFormRef.current.submitForm();
  };
  const handlePlanFormSubmit = async () => {
    if (planFormRef.current) await planFormRef.current.submitForm();
  };
  const handleClientUserFormSubmit = async () => {
    if (clientUserFormRef.current) clientUserFormRef.current.submitForm();
  };
  const handleClientUsersFormSubmit = async () => {
    if (collaboratorsFormRef.current) collaboratorsFormRef.current.submitForm();
  };
  const handleClientLayoutFormSubmit = async () => {
    if (layoutFormRef.current) await layoutFormRef.current.submitForm();
  };

  function handleNextSubmit() {
    switch (selectedStep) {
      case 0:
        return handleClientDetailsFormSubmit;
      case 1:
        return handlePlanFormSubmit;
      case 2:
        return handleClientUserFormSubmit;
      case 3:
        return handleClientUsersFormSubmit;
      case 4:
        return handleClientLayoutFormSubmit;
    }
  }
  const handleNext = () => {
    const submitForm = handleNextSubmit();
    submitForm && submitForm();
  };
  const handleBack = () => {
    setSelectedStep(selectedStep - 1);
  };

  const handleFinish = async () => {
    const submitForm = handleNextSubmit();
    submitForm && (await submitForm());
  };

  const { setClient, setCurrentClient } = useContext(ClientsContext);
  const path = window.location.pathname;
  const isRegister = path.includes("cadastrar");
  const onMount = async () => {
    if (isRegister) {
      setClient(null);
    } else {
      const clientId = path.split("/")[2];
      if (!clientId) return;
      const client = await clientsApi.getClient(clientId);
      setClient(client);
      setCurrentClient(client);
    }
  };
  useEffect(() => {
    onMount();
  }, [isRegister]);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, 0);
    }
  }, [selectedStep]);
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "auto",
      }}
      ref={scrollRef}
    >
      <div
        style={{
          width: "90%",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Typography
          variant="h4"
          sx={{ fontWeight: 500, fontSize: 24, marginTop: "20px" }}
        >
          {isRegister ? "Adicionar" : "Editar"} Cliente
        </Typography>
      </div>
      <div
        style={{
          width: "90%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <ClientFormsStepper activeStep={selectedStep} />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {selectedStep === 0 && (
          <ClientDetailsForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={clientDetailsFormRef}
          />
        )}
        {selectedStep === 1 && (
          <ClientPlanForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={planFormRef}
          />
        )}
        {selectedStep === 2 && (
          <ClientUserForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={clientUserFormRef}
          />
        )}
        {selectedStep === 3 && (
          <ClientCollaboratorsForm
            selectedStep={selectedStep}
            setSelectedStep={setSelectedStep}
            ref={collaboratorsFormRef}
          />
        )}
        {selectedStep === 4 && <ClientLayoutForm ref={layoutFormRef} />}
      </div>

      <ClientFormFooter
        selectedStep={selectedStep}
        handleBack={handleBack}
        handleNext={handleNext}
        handleSave={handleFinish}
      />
    </div>
  );
}
